import { Link } from "react-router-dom";

export default function BlogCard({ blog }) {
  return (
    <article className="oglitz-blog-card">
      <span className="oglitz-blog-card__category">{blog.category}</span>
      <h3>{blog.title}</h3>
      <p>{blog.excerpt}</p>

      <div className="oglitz-blog-card__meta">
        <span>{blog.readingTime}</span>
        <span>{blog.date}</span>
      </div>

      <Link to={`/blogs/${blog.slug}`} className="oglitz-blog-card__link">
        Read Article →
      </Link>
    </article>
  );
}
